import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ViewService {
  currentView: 'admin' | 'user' = 'user';

  constructor(private authService: AuthService) {
    this.authService.authReady.subscribe(() => {
      if (this.authService.isAdmin()) {
        this.currentView = 'admin';
      } else {
        this.currentView = 'user';
      }
    });
  }

  setView(view: 'admin' | 'user') {
    this.currentView = view;
  }
}
